// init
import {AuthLoginWebbUser} from './user-accounts';

// add identity docs
export const WebbSearchWorker = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.webbGetWorkerInfo(item)
  return (result); 
}

export const WebbSearchItem = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credCreateUserCredential(item)
  return (result); 
}